export default __webpack_public_path__ + "static/media/mat.3c22e7c1.svg";